/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NegotiableInputs */

const en_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiable`)
};

const es_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociable`)
};

const fr_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Négociable`)
};

const de_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhandelbar`)
};

const ja_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格交渉可`)
};

const zh_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可议价`)
};

const ar_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قابل للتفاوض`)
};

const id_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa Dinegosiasi`)
};

const it_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattabile`)
};

const ru_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возможен торг`)
};

const pt_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociável`)
};

const ko_negotiable = /** @type {(inputs: NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 협의 가능`)
};

/**
* | output |
* | --- |
* | "Negotiable" |
*
* @param {NegotiableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const negotiable = /** @type {((inputs?: NegotiableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NegotiableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_negotiable(inputs)
	if (locale === "es") return es_negotiable(inputs)
	if (locale === "fr") return fr_negotiable(inputs)
	if (locale === "de") return de_negotiable(inputs)
	if (locale === "ja") return ja_negotiable(inputs)
	if (locale === "zh") return zh_negotiable(inputs)
	if (locale === "ar") return ar_negotiable(inputs)
	if (locale === "id") return id_negotiable(inputs)
	if (locale === "it") return it_negotiable(inputs)
	if (locale === "ru") return ru_negotiable(inputs)
	if (locale === "pt") return pt_negotiable(inputs)
	return ko_negotiable(inputs)
});